
function $track(category, event, metas) {
  trackKlaviyo(`${category} - ${event}`, metas);
  trackGA(category, event);
}

function trackKlaviyo(event, metas) {
  window._learnq = window._learnq || [];
  window._learnq.push(["track", event, metas]);
  console.log("$trackKlaviyo()", event, metas);
}

function trackGA(category, event, label, value) {
  if (window.ga) {
    window.ga("send", {
      hitType: "event",
      eventCategory: category,
      eventAction: event,
      eventLabel: label,
      eventValue: value,
    });

    console.log("$trackGA()", event, label, value);
  } else {
    console.log("$trackGA() no window.ga()!");
  }
}

function klaviyoIdentify(email) {
  var _learnq = _learnq || [];
  _learnq.push(['identify', {
    '$email' : email
  }]);
}
